/**
 * @description
 * Client portal page for client users to access VSCode Lens data.
 * Redirects to the VSCode Lens interface for the full experience.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date 2025-01-10
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router';

/**
 * Client portal page component - redirects to VSCode Lens
 */
export function ClientPortal() {
  // Redirect to the VSCode Lens interface
  return <Navigate to="/portal/vscode-lens" replace />;
}

/*
 * © 2025 Byte Inc. All rights reserved.
 * This code is the confidential and proprietary information of Byte Inc.
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Byte Inc.
 */
